import { render, staticRenderFns } from "./items-config.vue?vue&type=template&id=5fdcc628"
import script from "./items-config.vue?vue&type=script&lang=js"
export * from "./items-config.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports